import { createContext, useContext, useEffect, useState, ReactNode } from "react";

type FooterVisibilityContextValue = {
  suppressed: boolean;
  setSuppressed: (value: boolean) => void;
};

const FooterVisibilityContext = createContext<FooterVisibilityContextValue | null>(null);

export function FooterVisibilityProvider({ children }: { children: ReactNode }) {
  const [suppressed, setSuppressed] = useState(false);
  return (
    <FooterVisibilityContext.Provider value={{ suppressed, setSuppressed }}>
      {children}
    </FooterVisibilityContext.Provider>
  );
}

export function useFooterVisibility() {
  const ctx = useContext(FooterVisibilityContext);
  if (!ctx) {
    if (import.meta.env.DEV) {
      throw new Error(
        "useFooterVisibility must be used within a FooterVisibilityProvider",
      );
    }
    return { suppressed: false, setSuppressed: () => {} };
  }
  return ctx;
}

export function useSuppressGlobalFooter() {
  const { setSuppressed } = useFooterVisibility();
  useEffect(() => {
    setSuppressed(true);
    return () => setSuppressed(false);
  }, [setSuppressed]);
}
